export default "__VITE_ASSET__DALINIv4__"